import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConnectableObservable, Observable } from 'rxjs';
import { publishLast } from 'rxjs/operators';
import { withSpinner } from "../../extensions/withSpinner.extension";
import { ChangeOrderGroup, ChangeOrderPlanOption, Lot, Plan, PlanOption } from "../../types";
import { API_ROOT } from "../../types/constants/appconstants";

@Injectable({
    "providedIn": "root"
})
export class ChangeOrderService {
    private http = inject(HttpClient);
    private apiRoot = inject(API_ROOT);
    private changeOrderBaseUrl = this.apiRoot + "api/changeorders";
    private getSchedulesLotChangeOrdersviewUrl = this.changeOrderBaseUrl + "/lotchangeordersview/";

    private lastLotId: number = null;
    private lotChangeOrders: ConnectableObservable<any>;

    getSchedulesLotChangeOrdersView(lotId: number): Observable<ChangeOrderGroup[]> {
        if (this.lastLotId === null || this.lastLotId !== lotId) {
            this.lastLotId = lotId;

            this.lotChangeOrders = withSpinner(this.http).get<ChangeOrderGroup[]>(this.getSchedulesLotChangeOrdersviewUrl + lotId).pipe(
                publishLast()
            ) as ConnectableObservable<ChangeOrderGroup[]>;
            this.lotChangeOrders.connect();
        }

        return this.lotChangeOrders;
    }

    updateChangeOrderGroup(changeOrderGroup: ChangeOrderGroup): Observable<ChangeOrderGroup> {
        this.lastLotId = null;

        return withSpinner(this.http).patch<ChangeOrderGroup>(`${this.changeOrderBaseUrl}/update`, changeOrderGroup);
    }

    createBuildingJIO(lot: Lot, plan: Plan, changeOrderGroup: ChangeOrderGroup, changeOrderPlanOptions: ChangeOrderPlanOption[]): Observable<ChangeOrderGroup> {
        return withSpinner(this.http).post<ChangeOrderGroup>(`${this.changeOrderBaseUrl}/createbuildingjio`, { lot: lot, plan: plan, changeOrderGroup: changeOrderGroup, changeOrderPlanOptions: changeOrderPlanOptions });
    }

    createCancelBuildingChangeOrder(changeOrderGroup: ChangeOrderGroup): Observable<ChangeOrderGroup> {
        return withSpinner(this.http).post<ChangeOrderGroup>(`${this.changeOrderBaseUrl}/cancelbuildingjio`, changeOrderGroup);
    }

    createOptionChangeOrder(changeOrderGroup: ChangeOrderGroup): Observable<ChangeOrderGroup> {
        return withSpinner(this.http).post<ChangeOrderGroup>(`${this.changeOrderBaseUrl}/optionchangeorder`, changeOrderGroup);
    }

    clearLastLotId(): void {
        this.lastLotId = null;
    }
}